<template>
    <div _tmplitem="98" class="dv-full-screen-container" :style="css">
        <div _tmplitem="98" style="position: absolute;--animation-linear:1;--animation-type:ease;width:1920px;height:1080px;background-color:rgb(43 44 45);" class="div-full-screen">
            <div _tmplitem="98" v-if="readDataPermission.customcotrlfjxt" class="bigitem customcotrlfjxt bigechartitem" style="top: 400px; left: 1364px;position: absolute; width: 307px; height: 42px; transform: translate(0px, 0px); z-index: 1024;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;font-size:20px ;color:rgba(77, 191, 184, 1) ;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <custom1996568979237310465 ref="customcotrlfjxt" w="307" h="42" :initwidth="0" :initheight="0" comid="1996568979237310465" title="激活榜" fontsize="20" fontcolor="rgba(77, 191, 184, 1)" gradientcolor="rgba(54, 151, 186, 1)"></custom1996568979237310465>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.scrollingtablekpy9" class="bigitem scrollingtablekpy9 " style="top: 446px; left: 1364px;position: absolute; width: 540px; height: 573px; transform: translate(0px, 0px); z-index: 1023;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;height:190px;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <scrollingtable _tmplitem="51" :header-row-style="{'font-size':'12px','line-height':'40px','text-align':'center'}" :row-style="{'font-size':'12px','line-height':'40px','text-align':'center'}" :isheadshow="true" :showordernum="false" :scrollnum="3" tablebackgroundcolor="rgba(1, 57, 109, 1)" tableheadcolor="rgba(30, 76, 132, 1)" tablerowhovercolor="rgb(18 86 157 / 90%)" tablerowcolor="rgba(63, 123, 154, 1)" tablerowdoublecolor="rgba(22, 102, 145, 1)" tablebordercolor="#42669a" tableheadfontcolor="#fff" tablehoverfontcolor="#fff" tablerowfontcolor="#fff" :scrollheight="1" :scrolltime="25" :elcolumn="controlData.scrollingtablekpy9" :tabledata="fromData.scrollingtablekpy9" :h="573" :w="540"> </scrollingtable>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.chart251b" class="bigitem chart251b bigechartitem" style="top: 784px; left: 612px;position: absolute; width: 719px; height: 294px; transform: translate(0px, 0px); z-index: 1022;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <myechart _tmplitem="52" ref="chart251b" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chart251b"></myechart>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.chartfdcs" class="bigitem chartfdcs bigechartitem" style="top: 387px; left: 28px;position: absolute; width: 536px; height: 314px; transform: translate(0px, 0px); z-index: 1021;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <myechart _tmplitem="53" ref="chartfdcs" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartfdcs"></myechart>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.labtla0" class="bigitem labtla0 bigechartitem" style="top: 334px; left: 44px;position: absolute; width: 307px; height: 42px; transform: translate(0px, 0px); z-index: 1020;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;font-size:20px ;color:rgba(77, 191, 184, 1) ;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <custom1996568979237310465 ref="labtla0" w="307" h="42" :initwidth="0" :initheight="0" comid="1996568979237310465" title="订单增长趋势" fontsize="20" fontcolor="rgba(77, 191, 184, 1)" gradientcolor="rgba(54, 151, 186, 1)"></custom1996568979237310465>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.chartapvh" class="bigitem chartapvh bigechartitem" style="top: 162px; left: 604px;position: absolute; width: 707px; height: 529px; transform: translate(0px, 0px); z-index: 1019;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;--animation-type:ease;--animation-linear:infinite;--animation-color:#0ff;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <myechart _tmplitem="55" ref="chartapvh" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="china" mapurl="" :options="fromData.chartapvh"></myechart>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.chartv3yq" class="bigitem chartv3yq bigechartitem" style="top: 751px; left: 12px;position: absolute; width: 584px; height: 322px; transform: translate(0px, 0px); z-index: 1018;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <myechart _tmplitem="56" ref="chartv3yq" orienttype="horizontal" :echartroll="false" :maxechartrollnum="8" :echartrolltime="2" mapcity="" mapcode="" mapurl="" :options="fromData.chartv3yq"></myechart>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.groupa7gk" class="groupa7gk " style="overflow: hidden; width: 197px; height: 74px;top: 123px; left: 1391px;position: absolute; z-index: 1017;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 74px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="60" v-if="readDataPermission.title2kej" class="bigitem title2kej " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="60" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="57" ref="title2kej" :w="146" :h="29" :val="fromData.title2kej" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="60" v-if="readDataPermission.numz0kf" class="bigitem numz0kf " style="top: 39px; left: 13px; position: absolute;width: 73px; height: 35px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="60" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="58" ref="numz0kf" :num="fromData.numz0kf" content="" :w="73" :h="35" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="60" v-if="readDataPermission.img9909" class="bigitem img9909 " style="top: 16px; left: 0px; position: absolute;width: 197px; height: 21px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="60" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="59" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.groupo95s" class="groupo95s " style="overflow: hidden; width: 197px; height: 74px;top: 121px; left: 1661px;position: absolute; z-index: 1016;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 74px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="64" v-if="readDataPermission.title2ybq" class="bigitem title2ybq " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="64" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="61" ref="title2ybq" :w="146" :h="29" :val="fromData.title2ybq" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="64" v-if="readDataPermission.num9na6" class="bigitem num9na6 " style="top: 39px; left: 13px; position: absolute;width: 73px; height: 35px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="64" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="62" ref="num9na6" :num="fromData.num9na6" content="" :w="73" :h="35" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="64" v-if="readDataPermission.imgqzdu" class="bigitem imgqzdu " style="top: 16px; left: 0px; position: absolute;width: 197px; height: 21px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="64" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="63" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.group8ozy" class="group8ozy " style="overflow: hidden; width: 197px; height: 74px;top: 234px; left: 1387px;position: absolute; z-index: 1015;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 74px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="68" v-if="readDataPermission.titlepwkr" class="bigitem titlepwkr " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="68" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="65" ref="titlepwkr" :w="146" :h="29" :val="fromData.titlepwkr" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="68" v-if="readDataPermission.numr6we" class="bigitem numr6we " style="top: 39px; left: 13px; position: absolute;width: 73px; height: 35px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="68" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="66" ref="numr6we" :num="fromData.numr6we" content="" :w="73" :h="35" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="68" v-if="readDataPermission.imgnt6q" class="bigitem imgnt6q " style="top: 16px; left: 0px; position: absolute;width: 197px; height: 21px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="68" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="67" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.groupzb0h" class="groupzb0h " style="overflow: hidden; width: 197px; height: 74px;top: 239px; left: 1649px;position: absolute; z-index: 1014;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 74px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="72" v-if="readDataPermission.titlembdk" class="bigitem titlembdk " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="72" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="69" ref="titlembdk" :w="146" :h="29" :val="fromData.titlembdk" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="72" v-if="readDataPermission.numle0v" class="bigitem numle0v " style="top: 39px; left: 13px; position: absolute;width: 73px; height: 35px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="72" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="70" ref="numle0v" :num="fromData.numle0v" content="" :w="73" :h="35" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="72" v-if="readDataPermission.img02ud" class="bigitem img02ud " style="top: 16px; left: 0px; position: absolute;width: 197px; height: 21px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="72" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="71" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.grop172049523866578" class="grop172049523866578 " style="overflow: hidden; width: 197px; height: 74px;top: 121px; left: 98px;position: absolute; z-index: 1013;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 74px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="76" v-if="readDataPermission.sel172049443556333" class="bigitem sel172049443556333 " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="76" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="73" ref="sel172049443556333" :w="146" :h="29" :val="fromData.sel172049443556333" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="76" v-if="readDataPermission.sel172049450629719" class="bigitem sel172049450629719 " style="top: 39px; left: 13px; position: absolute;width: 73px; height: 35px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="76" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="74" ref="sel172049450629719" :num="fromData.sel172049450629719" content="" :w="73" :h="35" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="76" v-if="readDataPermission.sel172049435631387" class="bigitem sel172049435631387 " style="top: 16px; left: 0px; position: absolute;width: 197px; height: 21px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="76" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="75" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.groupdprz" class="groupdprz " style="overflow: hidden; width: 197px; height: 75.78px;top: 121px; left: 352px;position: absolute; z-index: 1012;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 75.78px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="80" v-if="readDataPermission.titlekj4w" class="bigitem titlekj4w " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29.74px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="80" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="77" ref="titlekj4w" :w="146" :h="29.74" :val="fromData.titlekj4w" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="80" v-if="readDataPermission.numjmj8" class="bigitem numjmj8 " style="top: 39.94px; left: 13px; position: absolute;width: 73px; height: 35.84px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="80" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="78" ref="numjmj8" :num="fromData.numjmj8" content="" :w="73" :h="35.84" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="80" v-if="readDataPermission.imgjycv" class="bigitem imgjycv " style="top: 16.430000000000007px; left: 0px; position: absolute;width: 197px; height: 21.53px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="80" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="79" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21.53" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.groupwkz0" class="groupwkz0 " style="overflow: hidden; width: 197px; height: 74px;top: 218px; left: 98px;position: absolute; z-index: 1011;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 74px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="84" v-if="readDataPermission.titles6q6" class="bigitem titles6q6 " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="84" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="81" ref="titles6q6" :w="146" :h="29" :val="fromData.titles6q6" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="84" v-if="readDataPermission.numl5qn" class="bigitem numl5qn " style="top: 39px; left: 13px; position: absolute;width: 73px; height: 35px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="84" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="82" ref="numl5qn" :num="fromData.numl5qn" content="" :w="73" :h="35" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="84" v-if="readDataPermission.imghwex" class="bigitem imghwex " style="top: 16px; left: 0px; position: absolute;width: 197px; height: 21px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="84" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="83" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.group8dqw" class="group8dqw " style="overflow: hidden; width: 197px; height: 74px;top: 218px; left: 352px;position: absolute; z-index: 1010;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                <div _tmplitem="98" class="" style=" width: 197px; height: 74px;pointer-events: auto; --animation-linear:1;--animation-type:ease;--animation:2s;--animation-flash:0.2s;">
                    <div _tmplitem="88" v-if="readDataPermission.titlew7g6" class="bigitem titlew7g6 " style="top: 0px; left: 12px; position: absolute;width: 146px; height: 29px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                        <div _tmplitem="88" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <titlecontrol _tmplitem="85" ref="titlew7g6" :w="146" :h="29" :val="fromData.titlew7g6" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:16px ;color:rgb(255, 255, 255) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                        </div>
                    </div>
                    <div _tmplitem="88" v-if="readDataPermission.numvgql" class="bigitem numvgql " style="top: 39px; left: 13px; position: absolute;width: 73px; height: 35px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                        <div _tmplitem="88" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <digitalflop _tmplitem="86" ref="numvgql" :num="fromData.numvgql" content="" :w="73" :h="35" :len="0" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;line-height:40px ;font-size:24px ;color:rgba(0, 229, 237, 1) ;text-align:left;border-radius:0px;border-width:0px ;border-style:solid ;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);font-weight: bold;"></digitalflop>
                        </div>
                    </div>
                    <div _tmplitem="88" v-if="readDataPermission.imgaj5f" class="bigitem imgaj5f " style="top: 16px; left: 0px; position: absolute;width: 197px; height: 21px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto;  ">
                        <div _tmplitem="88" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                            <bigimg _tmplitem="87" url="/img2026198159008505858/90089243-a8e0-4ef8-9920-462c19e8a625.png" w="197" h="21" :enablemask="false" maskimage=""></bigimg>
                        </div>
                    </div>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.titlenvrs" class="bigitem titlenvrs " style="top: 15px; left: 923px;position: absolute; width: 201px; height: 40px; transform: translate(0px, 0px); z-index: 109;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;font-size:26px ;color:rgba(59, 198, 255, 1) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <titlecontrol _tmplitem="89" ref="titlenvrs" :w="201" :h="40" :val="fromData.titlenvrs" cssstyle="--animation-linear:1;--animation-type:ease;opacity:1;font-size:26px ;color:rgba(59, 198, 255, 1) ;border-radius:0px;border-width:0px ;border-style:solid ;line-height:40px ;text-align:left;font-family:'Microsoft YaHei';--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"></titlecontrol>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.imgdhsh" class="bigitem imgdhsh " style="top: 736px; left: 606px;position: absolute; width: 732px; height: 335px; transform: translate(0px, 0px); z-index: 108;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="90" url="/img2026198159008505858/889688ba-8fa4-42d5-a85d-664203ddf52f.png" w="732" h="335" :enablemask="false" maskimage=""></bigimg>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.img6ncp" class="bigitem img6ncp " style="top: 60px; left: 1348px;position: absolute; width: 569px; height: 309px; transform: translate(0px, 0px); z-index: 107;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="91" url="/img2026198159008505858/889688ba-8fa4-42d5-a85d-664203ddf52f.png" w="569" h="309" :enablemask="false" maskimage=""></bigimg>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.imgxskx" class="bigitem imgxskx " style="top: 384px; left: 1348px;position: absolute; width: 559px; height: 683px; transform: translate(0px, 0px); z-index: 106;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="92" url="/img2026198159008505858/889688ba-8fa4-42d5-a85d-664203ddf52f.png" w="559" h="683" :enablemask="false" maskimage=""></bigimg>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.img2ebj" class="bigitem img2ebj " style="top: 737px; left: 14px;position: absolute; width: 579px; height: 336px; transform: translate(0px, 0px); z-index: 105;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="93" url="/img2026198159008505858/889688ba-8fa4-42d5-a85d-664203ddf52f.png" w="579" h="336" :enablemask="false" maskimage=""></bigimg>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.imgcfd4" class="bigitem imgcfd4 " style="top: 331px; left: 12px;position: absolute; width: 577px; height: 387px; transform: translate(0px, 0px); z-index: 104;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="94" url="/img2026198159008505858/889688ba-8fa4-42d5-a85d-664203ddf52f.png" w="577" h="387" :enablemask="false" maskimage=""></bigimg>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.img545q" class="bigitem img545q " style="top: 57px; left: 14px;position: absolute; width: 573px; height: 259px; transform: translate(0px, 0px); z-index: 103;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="95" url="/img2026198159008505858/889688ba-8fa4-42d5-a85d-664203ddf52f.png" w="573" h="259" :enablemask="false" maskimage=""></bigimg>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.img9q5z" class="bigitem img9q5z " style="top: -27px; left: 0px;position: absolute; width: 1920px; height: 109px; transform: translate(0px, 0px); z-index: 102;pointer-events: auto;  ">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);">
                    <bigimg _tmplitem="96" url="/img2026198159008505858/29f641cb-d682-4bf1-bd75-42730325bb92.png" w="1920" h="109" :enablemask="false" maskimage=""></bigimg>
                </div>
            </div>
            <div _tmplitem="98" v-if="readDataPermission.video3fc5" class="bigitem video3fc5 " style="top: 0px; left: 0px;position: absolute; width: 1920px; height: 1080px; transform: translate(0px, 0px); z-index: 101;pointer-events: auto; mix-blend-mode:screen; --objectfit:cover">
                <div _tmplitem="98" class="itemcontent " style="--animation-linear:1;--animation-type:ease;opacity:1;border-radius:0px;border-width:0px ;border-style:solid ;--animation:2s;--animation-flash:0.2s;transform:  rotateX(0deg) rotateY(0deg) rotateZ(0deg);"> <video _tmplitem="97" class="art-video" preload="metadata" crossorigin="anonymous" src="/img2026198159008505858/hieui98oid_1675409080094_4wtvy7l8fn.mp4" autoplay="autoplay" loop="loop" muted="true" style="width:1920px;height:1080px"></video> </div>
            </div>
        </div>
        <fromdialog _tmplitem="98" ref="reffromdialog"></fromdialog>
    </div>
</template>
<script>
    import china from './china.json'
    import * as echarts from 'echarts'
    import service from '@/utils/service.js'
    import custom1996568979237310465 from './custom1996568979237310465.vue'
    export default {
        methods: {
            // ===================== 新增接口对接方法 =====================
            async fetchAnalysisData() {
                const baseUrl = (this.baseUrl || '') + '/api/admin/analysis';

                // 从 URL 或数据中获取 token
                const token = this.$route.query.token || this.adminToken;
                console.log(token)
                if (!token) {
                    console.warn('未获取到 admin-authorization 令牌');
                    return;
                }

                const config = {
                    headers: {
                        'admin-authorization': `${token}`
                    }
                };

                try {
                    // 1. 新增用户/订单数量
                    const resCounts = await service.get(`${baseUrl}/echarts/counts-new`, config);
                    if (resCounts && resCounts.code === 1) {
                        const data = resCounts.data;
                        this.fromData.sel172049450629719 = data.todayNewUsers || 0;
                        this.fromData.numjmj8 = data.weekNewUsers || 0;
                        this.fromData.numl5qn = data.todayNewOrders || 0;
                        this.fromData.numvgql = data.weekNewOrders || 0;
                    }

                    // 2. 总览数量
                    const resOverview = await service.get(`${baseUrl}/echarts/overview`, config);
                    if (resOverview && resOverview.code === 1) {
                        const data = resOverview.data;
                        this.fromData.numz0kf = data.totalCards || 0;
                        this.fromData.num9na6 = data.totalUsers || 0;
                        this.fromData.numr6we = data.totalActivations || 0;
                        this.fromData.numle0v = data.totalAgents || 0;
                    }

                    // 3. 订单增长趋势
                    const resTrend = await service.get(`${baseUrl}/echarts/order-trend`, config);
                    if (resTrend && resTrend.code === 1) {
                        const data = resTrend.data;
                        this.fromData.chartfdcs.xAxis[0].data = data.dates || [];
                        this.fromData.chartfdcs.series[0].data = data.finished || [];
                        this.fromData.chartfdcs.series[1].data = data.unpaid || [];
                    }

                    // 4. 单码应用制卡 Top7
                    const resTop7 = await service.get(`${baseUrl}/echarts/top7-single-app`, config);
                    if (resTop7 && resTop7.code === 1) {
                        const data = resTop7.data;
                        this.fromData.chart251b.xAxis[0].data = data.names || [];
                        this.fromData.chart251b.series[0].data = data.activateCounts || [];
                        this.fromData.chart251b.series[1].data = data.createCounts || [];
                    }

                    // 5. 今日激活榜 Top15
                    const resLeader = await service.get(`${baseUrl}/echarts/activation-leader`, config);
                    if (resLeader && resLeader.code === 1) {
                        const data = resLeader.data;
                        this.fromData.scrollingtablekpy9 = data.list || [];
                    }

                    // 6. IP 地理分布
                    const resIpGeo = await service.get(`${baseUrl}/echarts/ip-geo`, config);
                    if (resIpGeo && resIpGeo.code === 1) {
                        const data = resIpGeo.data;
                        // 更新视觉映射最大值
                        this.fromData.chartapvh.visualMap.max = data.visualMapMax || 100;
                        // 更新散点数据
                        this.fromData.chartapvh.series[0].data = data.scatterData || [];
                        // 更新地图区域数据
                        this.fromData.chartapvh.series[1].data = data.mapData || [];
                        // 更新 Top10 特效散点数据
                        this.fromData.chartapvh.series[3].data = data.effectScatterData || [];
                    }
                } catch (error) {
                    console.error('获取分析数据失败:', error);
                }
            },
            created_sys() {
                ///系统方法 判断页面大小 使其自动适应
                let $this = this
                this.w = this.w === undefined ? 1920 : this.w
                $this.css = $this.fullScreenCss($this, this.screentype)
                window.addEventListener('resize', () => {
                    $this.css = $this.fullScreenCss($this, this.screentype)
                })
                if (this.loadfunmounted_sys !== undefined) {
                    this.$nextTick(() => {
                        this.loadfunmounted_sys()
                    })
                }
            },
            loadsysmounted() {
                echarts.registerMap("china", china);
            },
            fullScreenCss(t, e) {
                if ("none" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}    ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`;
                if ("w" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${document.body.clientWidth/t.w});  ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`;
                if ("h" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${document.body.clientHeight/t.h});  ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`;
                if ("full" === e) return `  width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"}  transform: scale(${document.body.clientWidth/t.w},${document.body.clientHeight/t.h});  ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`; {
                    let e = document.body.clientHeight / t.h,
                        n = document.body.clientWidth / t.w,
                        i = e > n ? n : e,
                        o = (document.body.clientWidth - i * t.w) / 2;
                    return o = o > 0 ? "left:" + o + "px;" : "", o + ` transform: scale(${i}); width: ${t.w}px;height: ${t.h}px; ${""===t.bg?"":"background-image:url("+t.bg+");    background-repeat: no-repeat;background-size: cover;"} ${""===t.bgColor?"":"background-color:"+t.bgColor+";"}`
                }
            },
            loadfunmounted_sys() {
                if (this.loadsysmounted !== undefined) {
                    this.loadsysmounted();
                }
                if (this.loadfunmounted !== undefined) {
                    let isreturn = this.loadfunmounted();
                    if (isreturn == false) {
                        return;
                    }
                }

                // 使用新的接口对接方法
                this.fetchAnalysisData();
                if (this.controlTimer.analysisData != null) {
                    clearInterval(this.controlTimer.analysisData);
                }
                this.controlTimer.analysisData = setInterval(() => {
                    this.fetchAnalysisData();
                }, 60000);
            }
        },
        created() {
            this.created_sys();

            // 从 URL 参数获取 base_url
            const urlBaseUrl = this.$route.query.base_url;
            if (urlBaseUrl) {
                // 去掉末尾的 /
                this.baseUrl = urlBaseUrl.replace(/\/+$/, '');
            }

            // 从 URL 参数获取 token
            const urlToken = this.$route.query.token;
            if (urlToken) {
                this.adminToken = urlToken;
            }

            // 监听父级 postMessage 消息传递 token 和 base_url
            window.addEventListener('message', (event) => {
                if (event.data && event.data.type === 'SET_TOKEN') {
                    this.adminToken = event.data.token;
                    this.fetchAnalysisData(); // 立即刷新数据
                }
                if (event.data && event.data.type === 'SET_BASE_URL') {
                    this.baseUrl = (event.data.baseUrl || '').replace(/\/+$/, '');
                    this.fetchAnalysisData(); // 立即刷新数据
                }
            });

            if (this.loadfunmounted !== undefined) {
                this.$nextTick(() => {
                    this.loadfunmounted();
                });
            }
        },
        data() {
            return {
                adminToken: '', // 用于存储外部传入的 token
                baseUrl: '', // 用于存储外部传入的 base_url
                w: 1920,
                css: ``,
                h: 1080,
                bg: ``,
                bgColor: `rgb(43 44 45)`,
                fromData: {
                    scrollingtablekpy9: [{
                        id: 1001,
                        active: 8,
                        nickname: `王小虎`,
                        username: `wangxiaohu888`,
                        money: 268.9,
                        apps: 156.5,
                        cards: 580
                    }, {
                        id: 1002,
                        active: 0,
                        nickname: `李梦琪`,
                        username: `limengqi777`,
                        money: 0,
                        apps: 98.2,
                        cards: 0
                    }, {
                        id: 1003,
                        active: 15,
                        nickname: `张浩然`,
                        username: `zhanghaoran999`,
                        money: 1250.75,
                        apps: 489.8,
                        cards: 1890.5
                    }, {
                        id: 1004,
                        active: 3,
                        nickname: `刘思雨`,
                        username: `liusiyu666`,
                        money: 89.5,
                        apps: 0,
                        cards: 120.3
                    }, {
                        id: 1005,
                        active: 7,
                        nickname: `陈俊宇`,
                        username: `chenjunyu555`,
                        money: 688,
                        apps: 320,
                        cards: 756.8
                    }],
                    chart251b: {
                        backgroundColor: ``,
                        tooltip: {
                            show: true,
                            trigger: `axis`,
                            axisPointer: {
                                type: `shadow`
                            }
                        },
                        grid: {
                            top: `8%`,
                            left: `1%`,
                            right: `1%`,
                            bottom: `8%`,
                            containLabel: true
                        },
                        legend: {
                            itemGap: 50,
                            data: [`激活数量`, `制卡数量`],
                            textStyle: {
                                color: `#f9f9f9`,
                                borderColor: `#fff`,
                                fontSize: 16
                            },
                            right: 10,
                            y: 20
                        },
                        xAxis: [{
                            type: `category`,
                            boundaryGap: true,
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: `rgba(255,255,255,.5)`
                                }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: `#fff`,
                                    margin: 16
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: [`微信`, `支付宝`, `抖音`, `淘宝`, `京东`, `拼多多`, `美团`, `快手`, `小红书`, `哔哩哔哩`]
                        }],
                        yAxis: [{
                            type: `value`,
                            min: 0,
                            max: 1200,
                            splitNumber: 7,
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: `#0a3256`
                                }
                            },
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                margin: 20,
                                textStyle: {
                                    color: `#65F5FD`
                                }
                            },
                            axisTick: {
                                show: false
                            }
                        }],
                        series: [{
                            name: `激活数量`,
                            type: `bar`,
                            stack: `app`,
                            barWidth: 20,
                            tooltip: {
                                show: true
                            },
                            label: {
                                show: false,
                                position: `top`,
                                textStyle: {
                                    color: `#fff`
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: {
                                        colorStops: [{
                                            offset: 0,
                                            color: `rgba(0,179,202,.9)`
                                        }, {
                                            offset: 1,
                                            color: `rgba(2,39,47,.5)`
                                        }],
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        type: `linear`,
                                        global: false
                                    }
                                }
                            },
                            data: [890, 780, 650, 580, 520, 480, 450, 420, 380, 350]
                        }, {
                            name: `制卡数量`,
                            type: `line`,
                            showAllSymbol: true,
                            symbol: `emptyCircle`,
                            symbolSize: 6,
                            lineStyle: {
                                normal: {
                                    color: `#28ffb3`
                                }
                            },
                            label: {
                                show: false
                            },
                            itemStyle: {
                                normal: {
                                    color: `#28ffb3`
                                }
                            },
                            tooltip: {
                                show: true
                            },
                            data: [950, 820, 700, 610, 550, 490, 460, 430, 390, 360]
                        }]
                    },
                    chartfdcs: {
                        backgroundColor: ``,
                        tooltip: {
                            trigger: `axis`,
                            backgroundColor: `transparent`,
                            axisPointer: {
                                lineStyle: {
                                    color: {
                                        type: `linear`,
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0,
                                            color: `rgba(126,199,255,0)`
                                        }, {
                                            offset: 0.5,
                                            color: `rgba(126,199,255,1)`
                                        }, {
                                            offset: 1,
                                            color: `rgba(126,199,255,0)`
                                        }],
                                        global: false
                                    }
                                }
                            }
                        },
                        legend: {
                            align: `left`,
                            right: `10%`,
                            top: `10%`,
                            type: `plain`,
                            textStyle: {
                                color: `#7ec7ff`,
                                fontSize: 16
                            },
                            itemGap: 25,
                            itemWidth: 18,
                            icon: `path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z`,
                            data: [{
                                name: `已支付订单`
                            }, {
                                name: `未支付订单`
                            }]
                        },
                        grid: {
                            top: `15%`,
                            left: `10%`,
                            right: `10%`,
                            bottom: `15%`
                        },
                        xAxis: [{
                            type: `category`,
                            boundaryGap: false,
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: `#233653`
                                }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: `#7ec7ff`,
                                    padding: 16,
                                    fontSize: 14
                                }
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: `#192a44`
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            data: [`3.26`, `3.27`, `3.28`, `3.29`, `3.30`, `3.31`]
                        }],
                        yAxis: [{
                            name: `订单数`,
                            nameTextStyle: {
                                color: `#7ec7ff`,
                                fontSize: 16,
                                padding: 10
                            },
                            min: 0,
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: `#192a44`
                                }
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: `#233653`
                                }
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: `#7ec7ff`,
                                    padding: 16
                                }
                            },
                            axisTick: {
                                show: false
                            }
                        }],
                        series: [{
                            name: `已支付订单`,
                            type: `line`,
                            symbol: `circle`,
                            showAllSymbol: true,
                            symbolSize: 0,
                            smooth: true,
                            lineStyle: {
                                normal: {
                                    width: 5,
                                    color: `rgba(25,163,223,1)`
                                },
                                borderColor: `rgba(0,0,0,.4)`
                            },
                            itemStyle: {
                                color: `rgba(25,163,223,1)`,
                                borderColor: `#646ace`,
                                borderWidth: 2
                            },
                            tooltip: {
                                show: true
                            },
                            areaStyle: {
                                normal: {
                                    color: {
                                        colorStops: [{
                                            offset: 0,
                                            color: `rgba(25,163,223,.3)`
                                        }, {
                                            offset: 1,
                                            color: `rgba(25,163,223, 0)`
                                        }],
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        type: `linear`,
                                        global: false
                                    },
                                    shadowColor: `rgba(25,163,223, 0.5)`,
                                    shadowBlur: 20
                                }
                            },
                            data: [`40`, `60`, `22`, `85`, `50`, `40`]
                        }, {
                            name: `未支付订单`,
                            type: `line`,
                            symbol: `circle`,
                            showAllSymbol: true,
                            symbolSize: 0,
                            smooth: true,
                            lineStyle: {
                                normal: {
                                    width: 5,
                                    color: `rgba(10,219,250,1)`
                                },
                                borderColor: `rgba(0,0,0,.4)`
                            },
                            itemStyle: {
                                color: `rgba(10,219,250,1)`,
                                borderColor: `#646ace`,
                                borderWidth: 2
                            },
                            tooltip: {
                                show: true
                            },
                            areaStyle: {
                                normal: {
                                    color: {
                                        colorStops: [{
                                            offset: 0,
                                            color: `rgba(10,219,250,.3)`
                                        }, {
                                            offset: 1,
                                            color: `rgba(10,219,250, 0)`
                                        }],
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        type: `linear`,
                                        global: false
                                    },
                                    shadowColor: `rgba(10,219,250, 0.5)`,
                                    shadowBlur: 20
                                }
                            },
                            data: [`20`, `50`, `12`, `65`, `30`, `60`]
                        }]
                    },
                    chartapvh: {
                        tooltip: {
                            padding: 0,
                            enterable: true,
                            transitionDuration: 1,
                            textStyle: {
                                color: `#000`,
                                decoration: `none`
                            }
                        },
                        visualMap: {
                            show: true,
                            min: 0,
                            max: 200,
                            left: `10%`,
                            top: `bottom`,
                            calculable: true,
                            seriesIndex: [1],
                            inRange: {
                                color: [`#04387b`, `#467bc0`]
                            }
                        },
                        geo: {
                            show: true,
                            map: `china`,
                            label: {
                                normal: {
                                    show: false
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            roam: false,
                            itemStyle: {
                                normal: {
                                    areaColor: `#023677`,
                                    borderColor: `#1180c7`
                                },
                                emphasis: {
                                    areaColor: `#4499d0`
                                }
                            }
                        },
                        series: [{
                            name: `散点`,
                            type: `scatter`,
                            coordinateSystem: `geo`,
                            data: [],
                            label: {
                                normal: {
                                    formatter: `{b}`,
                                    position: `right`,
                                    show: true
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: `#fff`
                                }
                            }
                        }, {
                            type: `map`,
                            map: `china`,
                            geoIndex: 0,
                            aspectScale: 0.75,
                            showLegendSymbol: false,
                            label: {
                                normal: {
                                    show: true
                                },
                                emphasis: {
                                    show: false,
                                    textStyle: {
                                        color: `#fff`
                                    }
                                }
                            },
                            roam: true,
                            itemStyle: {
                                normal: {
                                    areaColor: `#031525`,
                                    borderColor: `#3B5077`
                                },
                                emphasis: {
                                    areaColor: `#2B91B7`
                                }
                            },
                            animation: false,
                            data: []
                        }, {
                            name: `点`,
                            type: `scatter`,
                            coordinateSystem: `geo`,
                            zlevel: 6
                        }, {
                            name: `Top 5`,
                            type: `effectScatter`,
                            coordinateSystem: `geo`,
                            data: [],
                            showEffectOn: `render`,
                            rippleEffect: {
                                brushType: `stroke`
                            },
                            hoverAnimation: true,
                            label: {
                                normal: {
                                    formatter: `{b}`,
                                    position: `left`,
                                    show: false
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: `yellow`,
                                    shadowBlur: 10,
                                    shadowColor: `yellow`
                                }
                            },
                            zlevel: 1
                        }]
                    },
                    chartv3yq: {
                        grid: {
                            show: false,
                            top: 10,
                            bottom: 10
                        },
                        xAxis: [{
                            gridIndex: 0,
                            type: `value`,
                            show: false,
                            min: 0,
                            max: 100,
                            nameLocation: `middle`,
                            nameGap: 5
                        }],
                        yAxis: [{
                            gridIndex: 0,
                            min: 0,
                            show: false,
                            max: 100,
                            nameLocation: `middle`,
                            nameGap: 30
                        }],
                        series: [{
                            type: `effectScatter`,
                            symbol: `circle`,
                            symbolSize: 120,
                            label: {
                                normal: {
                                    show: true,
                                    formatter: `{b}`,
                                    color: `#FFF`,
                                    lineHeight: 15,
                                    textStyle: {
                                        fontSize: `30`
                                    }
                                }
                            },
                            itemStyle: {
                                normal: {
                                    borderWidth: `1`,
                                    borderType: `solid`,
                                    borderColor: `#00ffff`,
                                    shadowColor: `rgba(0, 0, 0, .6)`,
                                    shadowBlur: 10
                                }
                            },
                            data: [{
                                name: `95%
获取单码信息接口`,
                                value: [56, 48],
                                symbolSize: 110,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: {
                                            colorStops: [{
                                                offset: 0,
                                                color: `rgba(67, 186, 255, 0)`
                                            }, {
                                                offset: 1,
                                                color: `rgb(67, 186, 255)`
                                            }],
                                            x: 0.4,
                                            y: 0.3,
                                            r: 1,
                                            type: `radial`,
                                            global: false
                                        }
                                    }
                                }
                            }, {
                                name: `90%
单码登录`,
                                value: [30, 70],
                                symbolSize: 70,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: {
                                            colorStops: [{
                                                offset: 0,
                                                color: `rgba(67, 186, 255, 0)`
                                            }, {
                                                offset: 1,
                                                color: `rgb(67, 186, 255)`
                                            }],
                                            x: 0.4,
                                            y: 0.3,
                                            r: 1,
                                            type: `radial`,
                                            global: false
                                        }
                                    }
                                }
                            }, {
                                name: `88%
用户登录`,
                                value: [5, 43],
                                symbolSize: 60,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: {
                                            colorStops: [{
                                                offset: 0,
                                                color: `rgba(27, 96, 255, 0)`
                                            }, {
                                                offset: 1,
                                                color: `rgb(27, 96, 255)`
                                            }],
                                            x: 0.4,
                                            y: 0.3,
                                            r: 1,
                                            type: `radial`,
                                            global: false
                                        }
                                    }
                                }
                            }, {
                                name: `85%
单码心跳接口`,
                                value: [93, 30],
                                symbolSize: 70,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: {
                                            colorStops: [{
                                                offset: 0,
                                                color: `rgba(48, 191, 191, 0)`
                                            }, {
                                                offset: 1,
                                                color: `rgb(48, 191, 191)`
                                            }],
                                            x: 0.4,
                                            y: 0.3,
                                            r: 1,
                                            type: `radial`,
                                            global: false
                                        }
                                    }
                                }
                            }, {
                                name: `82%
获取会员信息（已登录）`,
                                value: [26, 25],
                                symbolSize: 65,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: {
                                            colorStops: [{
                                                offset: 0,
                                                color: `rgba(0, 166, 166, 0)`
                                            }, {
                                                offset: 1,
                                                color: `rgb(0, 166, 166)`
                                            }],
                                            x: 0.4,
                                            y: 0.3,
                                            r: 1,
                                            type: `radial`,
                                            global: false
                                        }
                                    }
                                }
                            }, {
                                name: `78%
获取程序变量`,
                                value: [75, 75],
                                symbolSize: 60,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: {
                                            colorStops: [{
                                                offset: 0,
                                                color: `rgba(84, 136, 255, 0)`
                                            }, {
                                                offset: 1,
                                                color: `rgb(84, 136, 255)`
                                            }],
                                            x: 0.4,
                                            y: 0.3,
                                            r: 1,
                                            type: `radial`,
                                            global: false
                                        }
                                    }
                                }
                            }, {
                                name: `75%
获取最新版本`,
                                value: [80, 15],
                                symbolSize: 55,
                                label: {
                                    normal: {
                                        textStyle: {
                                            fontSize: 14
                                        }
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: {
                                            colorStops: [{
                                                offset: 0,
                                                color: `rgba(12, 180, 255, 0)`
                                            }, {
                                                offset: 1,
                                                color: `rgb(12, 180, 255)`
                                            }],
                                            x: 0.4,
                                            y: 0.3,
                                            r: 1,
                                            type: `radial`,
                                            global: false
                                        }
                                    }
                                }
                            }]
                        }]
                    },
                    title2kej: `总卡密数量`,
                    numz0kf: 1343,
                    title2ybq: `总用户数量`,
                    num9na6: 1343,
                    titlepwkr: `总激活`,
                    numr6we: 1343,
                    titlembdk: `总代理`,
                    numle0v: 1343,
                    sel172049443556333: `今日新增用户`,
                    sel172049450629719: 1343,
                    titlekj4w: `本周新增用户`,
                    numjmj8: 1343,
                    titles6q6: `今日新增订单`,
                    numl5qn: 1343,
                    titlew7g6: `本周新增订单`,
                    numvgql: 1343,
                    titlenvrs: `指挥座舱`
                },
                controlTimer: {},
                controlData: {
                    scrollingtablekpy9: [{
                        prop: `id`,
                        label: `用户ID`,
                        width: `80`,
                        align: ``,
                        headeralign: ``,
                        classname: ``,
                        scopehtml: ``,
                        headscopehtml: ``,
                        minwidth: `180`,
                        flexAlign: ``,
                        showOverflowTooltip: false
                    }, {
                        prop: `nickname`,
                        label: `昵称`,
                        width: `120`,
                        align: ``,
                        headeralign: ``,
                        classname: ``,
                        scopehtml: ``,
                        headscopehtml: ``,
                        minwidth: `180`,
                        flexAlign: ``,
                        showOverflowTooltip: false
                    }, {
                        prop: `username`,
                        label: `账户`,
                        align: ``,
                        headeralign: ``,
                        classname: ``,
                        scopehtml: ``,
                        headscopehtml: ``,
                        minwidth: ``,
                        flexAlign: ``,
                        showOverflowTooltip: false,
                        width: `120`
                    }, {
                        prop: `active`,
                        label: `今日激活`,
                        width: `100`,
                        minwith: 120,
                        scopehtml: ``,
                        align: ``,
                        istotal: false,
                        flexAlign: ``,
                        headeralign: ``,
                        classname: ``,
                        headscopehtml: ``,
                        showOverflowTooltip: false
                    }, {
                        prop: `money`,
                        label: `账户余额`,
                        width: `100`,
                        minwith: 120,
                        scopehtml: ``,
                        align: ``,
                        istotal: false,
                        flexAlign: ``,
                        headeralign: ``,
                        classname: ``,
                        headscopehtml: ``,
                        showOverflowTooltip: false
                    }, {
                        prop: `apps`,
                        label: `应用额度`,
                        width: `100`,
                        minwith: 120,
                        scopehtml: ``,
                        align: ``,
                        istotal: false,
                        flexAlign: ``,
                        headeralign: ``,
                        classname: ``,
                        headscopehtml: ``,
                        showOverflowTooltip: false
                    }, {
                        prop: `cards`,
                        label: `卡密额度`,
                        width: `100`,
                        minwith: 120,
                        scopehtml: ``,
                        align: ``,
                        istotal: false,
                        flexAlign: ``,
                        headeralign: ``,
                        classname: ``,
                        headscopehtml: ``,
                        showOverflowTooltip: false
                    }]
                },
                screentype: `w`,
                readDataPermission: {
                    customcotrlfjxt: true,
                    scrollingtablekpy9: true,
                    chart251b: true,
                    chartfdcs: true,
                    labtla0: true,
                    chartapvh: true,
                    chartv3yq: true,
                    title2kej: true,
                    numz0kf: true,
                    img9909: true,
                    groupa7gk: true,
                    title2ybq: true,
                    num9na6: true,
                    imgqzdu: true,
                    groupo95s: true,
                    titlepwkr: true,
                    numr6we: true,
                    imgnt6q: true,
                    group8ozy: true,
                    titlembdk: true,
                    numle0v: true,
                    img02ud: true,
                    groupzb0h: true,
                    sel172049443556333: true,
                    sel172049450629719: true,
                    sel172049435631387: true,
                    grop172049523866578: true,
                    titlekj4w: true,
                    numjmj8: true,
                    imgjycv: true,
                    groupdprz: true,
                    titles6q6: true,
                    numl5qn: true,
                    imghwex: true,
                    groupwkz0: true,
                    titlew7g6: true,
                    numvgql: true,
                    imgaj5f: true,
                    group8dqw: true,
                    titlenvrs: true,
                    imgdhsh: true,
                    img6ncp: true,
                    imgxskx: true,
                    img2ebj: true,
                    imgcfd4: true,
                    img545q: true,
                    img9q5z: true,
                    video3fc5: true
                }
            }
        },
        components: {
            custom1996568979237310465
        }
    }
</script>
<style scoped>
    .dv-full-screen-container {
        transform: scale(1);
        position: absolute;
        top: 0px;
        left: 0px;
        overflow: hidden;
        transform-origin: left top;
        z-index: 499;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        width: 1920px;
        height: 1080px;
        background-color: '#040404';
        background-size: cover;
        background-repeat: no-repeat;
    }

    .div-full-screen {
        background-size: cover;
        background-repeat: no-repeat;
    }

    .bigitem {
        position: absolute;
        will-change: transform;
    }

    .bigechartitem:hover {
        z-index: 1900 !important;
    }

    .layouttable {
        height: 100%;
        display: flex;
    }

    .layouttable .layouttable-item {
        height: 100%;
        position: relative;
        float: left;
    }

    .itemcontent {
        width: 100%;
        height: 100%;
    }

    .bigbutton {
        width: 100%;
        height: 100%;
        text-align: center;
    }
</style>
<style scoped>
    .dv-full-screen-container {
        transform: scale(1);
        position: absolute;
        top: 0px;
        left: 0px;
        overflow: hidden;
        transform-origin: left top;
        z-index: 499;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        width: 1920px;
        height: 1080px;
        background-color: "#040404";
        background-size: cover;
        background-repeat: no-repeat;
    }

    .div-full-screen {
        background-size: cover;
        background-repeat: no-repeat;
    }

    .bigitem {
        position: absolute;
        will-change: transform;
    }

    .bigechartitem:hover {
        z-index: 1900 !important;
    }

    .layouttable {
        height: 100%;
        display: flex;
    }

    .layouttable .layouttable-item {
        height: 100%;
        position: relative;
        float: left;
    }

    .itemcontent {
        width: 100%;
        height: 100%;
    }

    .bigbutton {
        width: 100%;
        height: 100%;
        text-align: center;
    }
</style>
